var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-encoding",class:{ mobile: _vm.isMobile, 'export-popup': _vm.isExportPopup }},[_vm._v(" "+_vm._s(_vm.isCheckShowText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }